import { useStore } from '@xyflow/react'
import { isCallAiSourceNode } from '../utils/ai-agent-utils'

export const useAiCall = () => {
  return useStore((state) => state.nodes.some((node) => isCallAiSourceNode(node)))
}
